import { useEffect, useState } from 'react';
import { useFileApi } from '../../../hooks/useFileApi';
import { EmailMessageDTO } from '../../../services/apiClient';
import FormField from '../FormField';
import ImageLink from '../ImageLink';

interface EmailMessageItemProps {
  data: EmailMessageDTO;
}

const EmailMessageItem: React.FC<EmailMessageItemProps> = ({ data }) => {
  const [messageFile, setMessageFile] = useState<string>('');
  const { getFileUrl } = useFileApi();

  useEffect(() => {
    const fetchMessageFile = async () => {
      try{
        const response = await getFileUrl(data.messageBodyFileId ?? '');
        setMessageFile(response.data?.url ?? '')
      }catch(error){
        console.error('Error fetching message file: ', error)
      }
    };
    fetchMessageFile();
  }, []);

  return (
    <div className="mb-10">
      <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
        <label className="text-sm font-medium text-gray-500 dark:text-gray-400 block mb-1">
          Message
        </label>
        <iframe src={messageFile} className='w-full h-96 border-0'></iframe>
        <span className="text-base text-gray-900 dark:text-gray-100"></span>
      </div>
      {data.emailAttachments && data.emailAttachments.length > 0 && (
        <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
          <label className="text-sm font-medium text-gray-500 dark:text-gray-400 block mb-2">
            Attachments ({data.emailAttachments.length})
          </label>
          <div className="space-y-2">
            {data.emailAttachments.map((attachment) => (
              <div
                key={attachment.id}
                className="flex items-center gap-2 bg-white dark:bg-gray-700 p-3 rounded border border-gray-200 dark:border-gray-600"
              >
                <svg
                  className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                  />
                </svg>
                <ImageLink fileId={attachment.fileRecordId ?? ''} label="Download" />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailMessageItem;
